<template>
  <div class="w-full h-full relative flex">
    <div :class="hidPaiement ? 'animation-apparition':'w-0 h-0'" class="absolute xl:bg-transparent xl:backdrop-blur-[3px] right-0 left-0 top-0 bottom-0 mx-auto my-auto z-20 transition-all duration-1000 overflow-hidden">
      <div class="w-full h-full relative flex items-center">
        <div  class="absolute w-[90%] h-min lg:w-1/2 flex items-center mx-auto my-auto left-0 right-0 top-0 bottom-0 overflow-hidden">
          <div class=" w-full">
            <div class="mt-4 mb-4 w-full rounded-lg overflow-hidden ">
              <div class="flex flex-col items-center overflow-hidden w-full">
                <div class="bg-gray-900 px-6 w-full py-2 text-center">
                  <p :class="hidPaiement ? 'delay-1000 opacity-100':'opacity-0'" class="text-2xl font-semibold leading-none text-white tracking-tighter lg:text-3xl">
                    {{ $t('creditermoncompte') }}
                  </p>
                  <input :class="hidPaiement ? 'delay-1000 opacity-100':'opacity-0'" v-model="montant" required type="number" id="input-group-1" class=" mt-8 bg-transparent border-b-[1px] text-white border-white  text-sm rounded-lg focus:ring-[#FF9900] focus:border-[#FF9900] block w-full p-2.5   focus:outline-none" :placeholder="$t('saissisezlemontantenxaf')" style="-moz-appearance:textfield"/>
                </div>
                <div :class="(typeof montant == 'number' && montant > 1) && hidPaiement ? 'delay-350 translate-y-0':'translate-y-full'" class="transform w-full transition-all duration-1000 bg-gray-900 px-6 py-2 relative">
                  <div v-if="montant == false" class="absolute w-full h-full z-50 "></div>
                  <campay-component :montant="this.montant"></campay-component>
                  <paypal-component :montant="this.montant"></paypal-component>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div @click="hidPaiement =! hidPaiement" class="w-full h-full"></div>
      </div>
    </div>
    <div :class="hidDebit ? 'animation-apparition':'w-0 h-0'" class="absolute xl:bg-transparent xl:backdrop-blur-[3px] right-0 left-0 top-0 bottom-0 mx-auto my-auto z-20 transition-all duration-1000 overflow-hidden">
      <div class="w-full h-full relative flex items-center">
        <div  class="absolute w-[90%] h-min lg:w-1/2 flex items-center mx-auto my-auto left-0 right-0 top-0 bottom-0 overflow-hidden">
          <div class=" w-full"> 
            <div class="mt-4 mb-4 w-full rounded-lg overflow-hidden ">
              <div class="flex flex-col items-center overflow-hidden w-full relative">
                <!-- erreur solde insuffisant -->
                <div :class="erreur ? 'translate-y-2':'-translate-y-full'" class="transition duration-1000 px-5 w-min space-x-4 h-16 flex items-center justify-center bg-red-500 absolute left-0 right-0 mx-auto rounded-md">
                  <svg class="h-8 object-contain" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 208 208" version="1.1">
                    <g id="surface1">
                    <path style=" stroke:none;fill-rule:nonzero;fill:#FFFFFF;fill-opacity:1;" d="M 199.246094 158.621094 L 120.027344 21.421875 C 110.332031 4.648438 94.515625 4.648438 84.820313 21.421875 L 5.601563 158.621094 C -4.09375 175.394531 3.847656 189.089844 23.207031 189.089844 L 181.644531 189.089844 C 201 189.089844 208.910156 175.394531 199.246094 158.621094 Z M 91.53125 60.351563 C 94.390625 57.273438 97.992188 55.734375 102.425781 55.734375 C 106.855469 55.734375 110.457031 57.246094 113.320313 60.292969 C 116.121094 63.308594 117.566406 67.125 117.566406 71.710938 C 117.566406 75.617188 111.65625 104.546875 109.6875 125.566406 L 95.4375 125.566406 C 93.714844 104.546875 87.28125 75.617188 87.28125 71.710938 C 87.28125 67.183594 88.730469 63.398438 91.53125 60.351563 Z M 113.105469 160.375 C 110.117188 163.269531 106.546875 164.746094 102.425781 164.746094 C 98.300781 164.746094 94.730469 163.269531 91.746094 160.375 C 88.757813 157.453125 87.28125 153.945313 87.28125 149.789063 C 87.28125 145.664063 88.757813 142.09375 91.746094 139.109375 C 94.730469 136.125 98.300781 134.648438 102.425781 134.648438 C 106.546875 134.648438 110.117188 136.125 113.105469 139.109375 C 116.089844 142.09375 117.566406 145.664063 117.566406 149.789063 C 117.566406 153.945313 116.089844 157.453125 113.105469 160.375 Z "/>
                    </g>
                  </svg>
                  <p class="text-white w-max">{{ messageErreur }}</p>
                </div>
                <div class="bg-gray-900 px-6 w-full py-2 text-center">
                  <p :class="hidDebit ? 'delay-1000 opacity-100':'opacity-0'" class="text-2xl font-semibold leading-none text-white tracking-tighter lg:text-3xl">
                    {{ $t('debitermoncompte') }}
                  </p>
                  <div :class="hidDebit ? 'delay-1000 opacity-100':'opacity-0'" class="w-full group">
                    <div class="flex w-full h-min mt-8 border-b-[1px] text-white border-white rounded-lg group-focus-within:border-b-[#FF9900]">
                      <div class="h-auto flex items-center">
                        <p class="text-white">+237</p>
                      </div>
                      <input v-model="form.to" required type="tel" id="input-group-1" class="bg-transparent text-sm rounded-lg focus:ring-[#FF9900] focus:border-[#FF9900] block w-full p-2.5   focus:outline-none" :placeholder="$t('saissisezvotrenumeroomoumomo')" style="-moz-appearance:textfield"/>
                    </div>
                  </div>
                  <input :class="hidDebit ? 'delay-1000 opacity-100':'opacity-0'" v-model="form.amount" required type="number" id="input-group-1" class=" mt-8 bg-transparent border-b-[1px] text-white border-white  text-sm rounded-lg focus:ring-[#FF9900] focus:border-[#FF9900] block w-full p-2.5   focus:outline-none" :placeholder="$t('saissisezlemontantenxaf')" style="-moz-appearance:textfield"/>
                  <input :class="hidDebit ? 'delay-1000 opacity-100':'opacity-0'" v-model="form.password" required type="password" id="input-group-1" class=" mt-8 bg-transparent border-b-[1px] text-white border-white  text-sm rounded-lg focus:ring-[#FF9900] focus:border-[#FF9900] block w-full p-2.5   focus:outline-none" :placeholder="$t('motdepassedevotreboutique')" style="-moz-appearance:textfield"/>
                  <div :class="hidDebit ? 'delay-1000 opacity-100':'opacity-0'" @click="SaveDebit" class="w-full h-[3rem] relative mt-8">
                      <div v-if="loadDebit" class="absolute bg-gray-900 z-20 w-full h-full flex items-center justify-center">
                        <svg aria-hidden="true" class="inline w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-white fill-[#FF9900]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                        </svg>
                      </div>
                      <div class="w-1/3 h-full absolute left-0 rounded-l-md overflow-hidden">
                          <button class="w-full h-full" type="button">
                              <img class="w-full h-full object-cover object-center" src="/images/OMMOMO.webp" alt="" srcset="">
                          </button>
                      </div>
                      <div class="w-2/3 h-full absolute right-0">
                          <button type="button"  class="w-full text-white h-full items-center text-center rounded-r-md  text-xl bg-[#FF0000] ">
                              <div class="w-1/2 flex items-center justify-center mx-auto space-x-1">
                                  <img class="w-8" src="/icons/coins.png" alt="" srcset="">
                                  <p class="text-center">{{ $t('payer') }}</p>
                              </div>
                          </button>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div @click="hidDebit =! hidDebit" class="w-full h-full"></div>
      </div>
    </div>
    <div class="w-full h-full flex relative">
      <div class="w-full flex flex-col flex-1 h-full ">
        <div class="w-full md:px-8 space-y-2">
          <div class="w-full h-[75%] overflow-hidden">
            <div class="w-full h-56 md:h-44 lg:flex relative">
              <div v-if="user" class="w-full backdrop-blur-[1px] lg:backdrop-blur-none space-y-3 md:space-y-0 lg:w-[60%] px-2 md:px-0 h-full md:flex py-2 items-center absolute z-10 lg:static justify-between">
                <div>
                  <p>{{ $t('montanttotal') }}</p>
                  <div class="flex space-x-2">
                    <div class="h-auto flex items-center">
                      <p class="md:text-[3rem] text-[2rem] font-semibold">{{ this.transformAmount(wallet.montant) }} </p>
                    </div>
                    <div class="h-auto flex items-center">
                      <img class="h-16" src="/images/berry.png" alt="" srcset="">
                    </div>
                  </div>
                  <div class="flex">
                    <div class="h-auto flex items-center">
                      <p>{{ $t('dernieretransaction') }} : <span class="text-red-500">28 </span></p>
                    </div>
                    <div class="h-auto flex items-center">
                      <svg class="h-5 fill-red-500" version="1.0" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 433.000000 577.000000"
                        preserveAspectRatio="xMidYMid meet">

                            <g transform="translate(0.000000,577.000000) scale(0.100000,-0.100000)"
                            stroke="none">
                            <path d="M2248 5551 c-352 -49 -603 -368 -568 -719 16 -151 64 -290 185 -532
                            36 -71 65 -132 65 -135 0 -3 -13 -5 -28 -5 -69 0 -238 39 -531 121 -373 106
                            -480 129 -593 129 -105 0 -124 -11 -114 -65 11 -58 41 -80 124 -93 256 -38
                            496 -294 625 -668 79 -226 108 -444 108 -794 0 -598 -66 -944 -216 -1133 -59
                            -74 -96 -97 -158 -97 -81 0 -150 45 -177 114 -23 62 20 126 85 126 36 0 82 38
                            91 77 4 13 4 52 2 87 -9 145 -123 217 -341 216 -132 -1 -213 -43 -277 -142
                            -54 -83 -67 -156 -47 -259 45 -221 189 -377 393 -425 53 -12 101 -15 204 -11
                            156 5 251 30 358 94 58 34 156 125 178 165 8 15 39 13 409 -28 220 -25 401
                            -46 402 -48 6 -5 -28 -251 -48 -350 -44 -221 -106 -361 -199 -448 -62 -58
                            -128 -82 -230 -82 -167 -2 -264 88 -230 213 17 63 61 106 141 138 82 33 146
                            83 165 130 22 51 17 131 -9 178 -46 81 -202 128 -351 105 -136 -21 -248 -95
                            -329 -218 -105 -159 -148 -374 -102 -507 57 -165 214 -317 408 -395 138 -55
                            195 -65 387 -64 161 1 182 3 265 28 223 68 374 196 471 401 82 174 114 353
                            114 657 l0 196 63 7 c208 22 350 61 502 138 83 43 115 66 191 142 98 97 144
                            172 184 300 31 97 39 330 16 462 -20 115 -63 236 -118 327 -54 92 -174 211
                            -264 264 -103 60 -110 91 -35 141 250 161 192 565 -108 759 -70 46 -183 86
                            -281 101 -36 5 -162 13 -280 16 -118 3 -232 9 -254 13 l-38 7 -78 225 c-43
                            124 -81 234 -86 245 -5 13 9 5 40 -23 75 -69 124 -87 236 -87 87 0 100 3 163
                            33 200 98 307 324 252 532 -41 153 -166 306 -306 373 -124 60 -295 87 -431 68z
                            m-127 -1758 c75 -167 166 -410 156 -419 -3 -3 -57 -2 -120 2 l-115 7 -12 45
                            c-31 124 -110 284 -186 379 -19 23 -34 44 -34 47 0 3 63 6 140 6 l141 0 30
                            -67z m665 48 c60 -27 114 -80 140 -136 68 -144 -19 -271 -217 -318 -25 -6 -27
                            -4 -39 51 -12 53 -93 364 -106 405 -5 15 4 17 88 17 69 0 104 -5 134 -19z
                            m279 -840 c73 -33 127 -112 159 -232 68 -264 -18 -558 -223 -759 -64 -63 -116
                            -99 -126 -88 -3 3 -10 76 -15 164 -18 290 -46 543 -97 897 l-6 37 134 0 c108
                            0 142 -4 174 -19z m-676 -53 c43 -218 61 -463 61 -814 l0 -284 -350 0 c-192 0
                            -350 3 -350 7 0 4 20 45 44 92 83 161 170 405 230 641 30 121 32 136 17 141
                            -14 6 -14 8 2 14 14 6 17 20 17 71 0 48 3 64 14 64 9 0 16 18 20 54 7 54 8 55
                            44 59 20 2 83 4 139 5 l102 2 10 -52z m-309 -28 c0 -5 -4 -10 -10 -10 -5 0
                            -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
                            </g>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="h-auto flex items-center justify-center">
                  <div class="md:space-y-3 flex md:block w-full md:w-auto space-x-2 md:space-x-0 px-2">
                    <div class="group w-1/2 md:w-auto">
                      <button  @click="hidPaiement =! hidPaiement" :class="user.status == 'block' ? 'opacity-50':'opacity-100'" :disabled="user.status == 'block'? true:false" class="w-full flex items-center justify-center space-x-1 px-2 py-2 bg-green-500 rounded-lg text-white mr-2 border border-transparent group-hover:bg-transparent group-hover:border-green-500 group-hover:text-green-500 transition-all duration-1000">
                        <div class="h-auto flex items-center">
                          <svg class="h-6 fill-white group-hover:fill-green-500 object-contain transition-all duration-1000" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                            <g id="surface1">
                            <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 236.84375 47.367188 C 132.175781 47.367188 47.367188 132.175781 47.367188 236.84375 C 47.367188 341.507813 132.175781 426.316406 236.84375 426.316406 C 341.507813 426.316406 426.316406 341.507813 426.316406 236.84375 C 426.316406 132.175781 341.507813 47.367188 236.84375 47.367188 Z M 331.578125 252.632813 L 252.632813 252.632813 L 252.632813 331.578125 C 252.632813 340.335938 245.539063 347.367188 236.84375 347.367188 C 228.144531 347.367188 221.050781 340.335938 221.050781 331.578125 L 221.050781 252.632813 L 142.105469 252.632813 C 133.410156 252.632813 126.316406 245.601563 126.316406 236.84375 C 126.316406 228.082031 133.410156 221.050781 142.105469 221.050781 L 221.050781 221.050781 L 221.050781 142.105469 C 221.050781 133.347656 228.144531 126.316406 236.84375 126.316406 C 245.539063 126.316406 252.632813 133.347656 252.632813 142.105469 L 252.632813 221.050781 L 331.578125 221.050781 C 340.277344 221.050781 347.367188 228.082031 347.367188 236.84375 C 347.367188 245.601563 340.277344 252.632813 331.578125 252.632813 Z "/>
                            </g>
                          </svg>
                        </div>
                        <div class="h-auto  flex items-center">
                          <p class="hidden md:block w-max">{{ $t('crediteportefeuille') }}</p>
                          <p class="md:hidden block">{{ $t('crediter') }}</p>
                        </div>
                      </button>
                    </div>
                    <div class="group w-1/2 md:w-auto ">
                      <button @click="hidDebit =! hidDebit" class="flex w-full items-center justify-center space-x-1 px-2 py-2 bg-red-500 rounded-lg text-white mr-2 border border-transparent group-hover:bg-transparent group-hover:border-red-500 group-hover:text-red-500 transition-all duration-1000">
                        <div class="h-auto flex items-center">
                          <svg class="h-6 fill-white group-hover:fill-red-500 object-contain transition-all duration-1000" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                            <g id="surface1">
                            <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 236.84375 47.367188 C 132.175781 47.367188 47.367188 132.175781 47.367188 236.84375 C 47.367188 341.507813 132.175781 426.316406 236.84375 426.316406 C 341.507813 426.316406 426.316406 341.507813 426.316406 236.84375 C 426.316406 132.175781 341.507813 47.367188 236.84375 47.367188 Z M 331.578125 252.632813 L 142.105469 252.632813 C 133.410156 252.632813 126.316406 245.601563 126.316406 236.84375 C 126.316406 228.082031 133.410156 221.050781 142.105469 221.050781 L 331.578125 221.050781 C 340.277344 221.050781 347.367188 228.082031 347.367188 236.84375 C 347.367188 245.601563 340.277344 252.632813 331.578125 252.632813 Z "/>
                            </g>
                          </svg>
                        </div>
                        <div class="h-auto flex items-center">
                          <p class="hidden md:block w-max">{{ $t('debiteportefeuille') }}</p>
                          <p class="md:hidden block">{{ $t('debiter') }}</p>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="h-full border-[1px] mr-2 hidden lg:block"></div>
              <div class="w-full lg:w-[40%] h-full bg-no-repeat bg-contain bg-center bg-white" style="background-image: url('/images/bgwallet2.jpg');">
                <div class=" w-full h-full">

                </div>
              </div>
            </div>
          </div>
          <div class="w-full nav space-x-2 flex flex-row scrollbar-hide overflow-x-auto">
            <router-link to="/mon-porte-feuille" class=" flex-shrink-0 h-full px-2 flex items-center text-gray-400">
              <p class="mx-auto">{{ $t('tout') }}</p>
            </router-link>  
            <router-link to="/credits" class=" flex-shrink-0 h-full px-2 flex items-center text-gray-400">
              <p class="mx-auto">{{ $t('credit') }}</p>
            </router-link> 
            <router-link to="/debits" class=" flex-shrink-0 h-full px-2 flex items-center text-gray-400">
              <p class="mx-auto">{{ $t('debit') }}</p>
            </router-link>
          </div>
        </div>
        <div class="h-full w-full overflow-hidden">
          <router-view name="eight"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paypalComponent from '../../paiementComponents/PayPalComponent.vue';
import campayComponent from '../../paiementComponents/CampayComponent.vue';
//import stripeComponent from '@/components/StripeComponent.vue';
export default {
  components: {
    paypalComponent,
    campayComponent,
    //stripeComponent
  },
  data(){
    return{
      user:'',
      wallet:'',
      hidPaiement:false,
      hidDebit:false,
      montant:'',
      form:{
        amount: '',
        to: '',
        description: '',
        external_reference: '',
        password:''
      },
      formRaw:'',
      loadDebit:false,
      erreur:'',
      messageErreur:'',
      music:'',
    }
  },
  beforeRouteLeave() {
    window.emitter.off("CloseModalPaiement")
  },
  created(){
    window.emitter.on("CloseModalPaiement", (data) => {
      this.hidPaiement = data
      this.montant = ''
    })
  },
  mounted(){
    this.user = this.requestAccueil[0]
    this.wallet = this.$store.state.wallet
    this.form.description = localStorage.getItem('langue') == 'fr' ? 'retrait d\'argent de la boutique ' + this.user.name +', ' : 'withdrawal of money from the '+this.user.name+' shop, '
  },
  methods:{
    transformAmount(value){
      var result = ''
      if(value > 0){
        var text = value.toString()
        var countElement = ''
        for (let i = 1; i <= text.length; i++) {
          result = text[text.length - i] + result
          countElement += text[text.length - i]
          if(countElement.length < text.length && countElement.length%3 == 0){
            result = (localStorage.getItem('langue') == 'fr' ? ',':'.') + result
          }
        }
      }else{
        result = value
      }
      
      return result
    },
    SaveDebit(){
      this.erreur = ''
      if(this.form.amount && this.form.to && this.form.password){
        if(this.form.amount <= this.wallet.montant ){
          if(this.form.to.length == 9){
            this.loadDebit = true
            this.formRaw = {
              amount: Math.floor(this.form.amount),
              to: '237'+this.form.to,
              description: this.form.description,
              password: this.form.password
            }
            this.formRaw.description += localStorage.getItem('langue') == 'fr' ? ' d\'un  montant de ' + Math.floor(this.form.amount) + ' Franc cfa, vers le numero ' + this.formRaw.to : 'amounting to '+Math.floor(this.form.amount)+' cfa francs, to number ' + this.formRaw.to

              this.axios.post(this.requestHttp + 'save-debit', {libelle: this.$crypto(JSON.stringify(['Retrait d\'argent vers le No: ' + this.form.to, 'Withdraw money to No: ' + this.form.to])), montant: this.$crypto(this.form.amount), walletId:this.$crypto(this.wallet.id), options: this.$crypto(JSON.stringify(this.formRaw))},{
                  headers: {
                      'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
                  },
              })
              .then(({data}) => {
                  if(this.$store.state.alltransaction.length > 0){
                    this.$store.state.alltransaction.unshift(data[0])
                  }
                  if(this.$store.state.allDebit.length > 0){
                    this.$store.state.allDebit.unshift(data[0])
                  }
                  this.wallet.montant -= this.form.amount
                  this.hidDebit = false
                  this.loadDebit = false
                  this.form.to = ''
                  this.form.amount = ''
                  this.form.password = ''
                  window.emitter.emit("alertSucces", ['Debit reussi', this.$i18n.messages[`${localStorage.getItem('langue')}`].debitsuccess])
              })
              .catch((error) => {
                this.music = new Audio(
                    "/music/error.mp3"
                  )
                  this.music.autoplay = true
                  console.log(error.response.data)
                  // this.erreur = JSON.parse(error.response.data[1]).message
                    if (Array.isArray(error.response.data)) {
                      const errorObj = error.response.data.find(item => {
                        try {
                          const parsedItem = JSON.parse(item);
                          return parsedItem.message;
                        } catch (e) {
                          return false;
                        }
                      });
                      this.erreur = errorObj ? JSON.parse(errorObj).message : '';
                    } else {
                      try {
                        const parsedData = JSON.parse(error.response.data);
                        this.erreur = parsedData.message;
                      } catch (e) {
                        this.erreur = error.response.data.message;
                      }
                    }

                  if(this.erreur == 'solde insuffisant'){
                    window.emitter.emit("alertError", ['solde insuffisant', this.$i18n.messages[`${localStorage.getItem('langue')}`].soldeinsuffissant])
                  }

                  if(this.erreur == 'Invalid phone number'){
                    this.messageErreur = this.$i18n.messages[`${localStorage.getItem('langue')}`].numeroincorrect
                  }

                  if(this.erreur == 'Insufficient  balance'){
                    this.messageErreur = this.$i18n.messages[`${localStorage.getItem('langue')}`].erreurcontactadmin
                  }

                  if(this.erreur == 'Numéro Orange non autorisé'){
                    this.messageErreur = this.$i18n.messages[`${localStorage.getItem('langue')}`].numeroraongenonautorise
                  }

                  if(this.erreur == 'Numéro MTN non autorisé'){
                    this.messageErreur = this.$i18n.messages[`${localStorage.getItem('langue')}`].numeromtnnonautorise
                  }

                  if(this.erreur == 'Password mismatch'){
                    this.messageErreur = this.$i18n.messages[`${localStorage.getItem('langue')}`].motdepasseincorrect
                  }

                  this.loadDebit = false
                  this.form.password = ''
                  setTimeout(() => {
                    this.erreur = ''
                  }, 3000);
                }
              )
          }else{
            this.erreur = 'le numero n\'a pas 9 chiffres'
            this.music = new Audio(
              "/music/error.mp3"
            )
            this.music.autoplay = true
            this.messageErreur = this.$i18n.messages[`${localStorage.getItem('langue')}`].numero9chiffre
            this.loadDebit = false
            setTimeout(() => {
              this.erreur = ''
            }, 5000);
          }
        }else{
          this.music = new Audio(
            "/music/error.mp3"
          )
          this.form.to = ''
          this.form.amount = ''
          this.music.autoplay = true
          this.erreur = 'solde insuffisant'
          this.messageErreur = this.$i18n.messages[`${localStorage.getItem('langue')}`].soldeinsuffissant
          setTimeout(() => {
            this.erreur = ''
          }, 3000);
        }
      }else{
        this.music = new Audio(
          "/music/error.mp3"
        )
        this.music.autoplay = true
        this.erreur = 'empty'
        this.messageErreur = this.$i18n.messages[`${localStorage.getItem('langue')}`].remplirleschamps
        setTimeout(() => {
          this.erreur = ''
        }, 3000);
      }
    }
  },
  computed:{
    requestAccueil(){
      return this.$store.state.dataAccueil
    },
    requestHttp(){
      return this.$store.state.api
    },
  }
}
</script>

<style>
  .nav .router-link-exact-active {
    border-color: #FF9900;
    border-bottom-width: 4px;
    color: black;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .component-frame{
    position:inherit !important;
    z-index:0 !important
  }
</style>